import * as yup from 'yup';

export const createFolderValidation = yup.object().shape({
  folderName: yup
    .string()
    .required('Folder name is required')
    .matches(
      /^[a-zA-Z0-9-!.*_'() ]+$/,
      "Folder names must only include letters, numbers, and the special characters: ! - _ . * ' ( )",
    ),
});
